import { useMutation } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import { LereSuggestedSpendingGraphRequest } from '~/components/LERE/types';

import LereService from '~/services/LereService';

export function useGenerateSuggestedSpendingGraph() {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: (params: LereSuggestedSpendingGraphRequest) => LereService.generateSuggestedSpendingGraph(params),
    onSuccess: () => {
      enqueueSnackbar('Graph generation started', { variant: 'success' });
    },
    onError: (error: Error) => {
      enqueueSnackbar(`Failed to generate graph: ${error.message || 'Unknown error'}`, {
        variant: 'error',
      });
    },
  });
}
